'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ResponsivePNG = require('../ResponsivePNG/ResponsivePNG');

var _ResponsivePNG2 = _interopRequireDefault(_ResponsivePNG);

var _Matchup = require('./Matchup.css');

var _Matchup2 = _interopRequireDefault(_Matchup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isHomeFirst = function isHomeFirst(league) {
  return league.sport_name === 'soccer';
};

var renderTeam = function renderTeam(team, boxScore, standings, eventStatus, alignment, ranking) {
  var isFirstTeam = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;

  var shortRecord = (0, _get2.default)(standings, alignment + '.short_record', '');
  var formattedRank = (0, _get2.default)(standings, alignment + '.formatted_rank', '');
  var teamLogo = (0, _get2.default)(team, 'logos.small', '');
  var teamScore = (0, _get2.default)(boxScore, 'score.' + alignment + '.score', '-');
  var teamRowClasses = (0, _classnames2.default)('teamRow', { separator: isFirstTeam });

  var recordAndRank = [shortRecord, formattedRank].filter(function (obj) {
    return obj;
  }).join(', ');

  if (!team || !Object.keys(team).length) {
    return _react2.default.createElement(
      'div',
      { className: teamRowClasses },
      _react2.default.createElement(
        'div',
        { className: 'teamName' },
        'TBD'
      )
    );
  }

  return _react2.default.createElement(
    'div',
    {
      className: 'jsx-' + _Matchup2.default.__scopedHash + ' ' + (teamRowClasses || '')
    },
    _react2.default.createElement(
      'div',
      {
        className: 'jsx-' + _Matchup2.default.__scopedHash + ' ' + 'logoWrapper'
      },
      _react2.default.createElement(_ResponsivePNG2.default, { src: teamLogo, width: '24px', height: '24px', alt: '' })
    ),
    _react2.default.createElement(
      'div',
      {
        className: 'jsx-' + _Matchup2.default.__scopedHash + ' ' + 'teamDetail'
      },
      ranking && _react2.default.createElement(
        'div',
        {
          className: 'jsx-' + _Matchup2.default.__scopedHash + ' ' + 'teamName'
        },
        '(' + ranking + ')',
        '\xA0'
      ),
      _react2.default.createElement(
        'div',
        {
          className: 'jsx-' + _Matchup2.default.__scopedHash + ' ' + 'teamName'
        },
        team.medium_name
      ),
      _react2.default.createElement(
        'div',
        {
          className: 'jsx-' + _Matchup2.default.__scopedHash + ' ' + 'teamRecord'
        },
        recordAndRank
      )
    ),
    (eventStatus === 'in_progress' || eventStatus === 'final') && _react2.default.createElement(
      'div',
      {
        className: 'jsx-' + _Matchup2.default.__scopedHash + ' ' + 'teamScore'
      },
      teamScore
    ),
    _react2.default.createElement(_style2.default, {
      styleId: _Matchup2.default.__scopedHash,
      css: _Matchup2.default.__scoped
    })
  );
};

var Matchup = function (_React$Component) {
  _inherits(Matchup, _React$Component);

  function Matchup() {
    _classCallCheck(this, Matchup);

    return _possibleConstructorReturn(this, (Matchup.__proto__ || Object.getPrototypeOf(Matchup)).apply(this, arguments));
  }

  _createClass(Matchup, [{
    key: 'renderTeams',
    value: function renderTeams() {
      // eslint-disable-next-line camelcase
      var _props$event = this.props.event,
          home_team = _props$event.home_team,
          away_team = _props$event.away_team,
          box_score = _props$event.box_score,
          standings = _props$event.standings,
          league = _props$event.league,
          event_status = _props$event.event_status;

      var homeFirst = isHomeFirst(league);
      var homeRanking = (0, _get2.default)(this.props.event, 'top_25_rankings.home', null);
      var awayRanking = (0, _get2.default)(this.props.event, 'top_25_rankings.away', null);

      if (homeFirst) {
        return _react2.default.createElement(
          'div',
          null,
          renderTeam(home_team, box_score, standings, event_status, 'home', homeRanking, true),
          renderTeam(away_team, box_score, standings, event_status, 'away', awayRanking)
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        renderTeam(away_team, box_score, standings, event_status, 'away', awayRanking, true),
        renderTeam(home_team, box_score, standings, event_status, 'home', homeRanking)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'jsx-' + _Matchup2.default.__scopedHash + ' ' + 'matchupContainer'
        },
        _react2.default.createElement(
          'a',
          { onClick: this.props.onMatchupCardClick, href: this.props.event.api_uri, className: 'jsx-' + _Matchup2.default.__scopedHash
          },
          _react2.default.createElement(
            'div',
            {
              className: 'jsx-' + _Matchup2.default.__scopedHash + ' ' + 'matchupInfo'
            },
            this.renderTeams()
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'jsx-' + _Matchup2.default.__scopedHash + ' ' + 'eventLinkContainer'
            },
            _react2.default.createElement(
              'div',
              {
                className: 'jsx-' + _Matchup2.default.__scopedHash + ' ' + 'eventLink'
              },
              'See Matchup >'
            )
          )
        ),
        _react2.default.createElement(_style2.default, {
          styleId: _Matchup2.default.__scopedHash,
          css: _Matchup2.default.__scoped
        })
      );
    }
  }]);

  return Matchup;
}(_react2.default.Component);

Matchup.propTypes = {
  event: _propTypes2.default.shape({
    box_score: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    league: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
    standings: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
    away_team: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    api_uri: _propTypes2.default.string.isRequired,
    home_team: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    // eslint-disable-next-line react/forbid-prop-types
    tv_listings_by_country_code: _propTypes2.default.object.isRequired,
    game_date: _propTypes2.default.string.isRequired,
    event_status: _propTypes2.default.string.isRequired,
    top_25_rankings: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    playoff: _propTypes2.default.shape({
      description: _propTypes2.default.string
    }),
    aggregate_result: _propTypes2.default.shape({
      description: _propTypes2.default.string,
      short_description: _propTypes2.default.string,
      round_description: _propTypes2.default.string
    })
  }).isRequired,
  onMatchupCardClick: _propTypes2.default.func
};

Matchup.defaultProps = {
  onMatchupCardClick: null
};
exports.default = Matchup;